import React from "react";
import SharedLayout from "./SharedLayout";
import comparisonTableImage from "../images/comparison_table.png";
import "../styles/PageWrappers.css";

const ClinicalStudyView = ({ user, onLoginClick }) => {
  return (
    <SharedLayout user={user} onLoginClick={onLoginClick}>
      <div className="clinical-study-wrapper">
        <h1
          style={{
            textAlign: "center",
            marginBottom: "2rem",
            color: "#2c3e50",
            fontSize: "2rem",
          }}
        >
          Clinical Study
        </h1>

        <div
          style={{
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            marginBottom: "2rem",
          }}
        >
          <div
            style={{
              fontSize: "1.1rem",
              lineHeight: "1.8",
              color: "#2c3e50",
            }}
          >
            <p style={{ marginBottom: "2rem" }}>
              <span className="sigmund-text">Sigmund</span> is an expert-guided
              human/machine hybrid "mind" applied to mental condition
              assessments. Employing the diagnoses of many psychiatric experts,
              and digitizing diagnostic approaches from multiple perspectives,{" "}
              <span className="sigmund-text">Sigmund</span> has effectively
              combined collective knowledge to determine a low-bias and
              highly-informed predisposition and probability assessment.
            </p>

            <p style={{ marginBottom: "2rem" }}>
              The approach employs machine-learning to calibrate/correlate and
              correlate mental condition ground truths with a purpose-built
              Reference Database of individual personal "signatures" to
              determine which combinations of biometric variables most
              accurately predict mental condition predispositions and
              probabilities. New incoming records can be compared to this matrix
              to predict high-accuracy, evidence-based
              predisposition/probability scores. York University's Clinical
              Study has generated the following results (the following chart
              predicts depression probabilities using three different
              approaches):
            </p>

            <ul
              style={{
                marginBottom: "2rem",
                paddingLeft: "1.5rem",
              }}
            >
              <li style={{ marginBottom: "1rem" }}>
                The original "expert-guided" approach where the predictive
                scoring is guided by psychoanalytical experts in advance of the
                application of machine-learning; and
              </li>
              <li>
                two "supervised" approaches where no expert guidance is provided
                in advance of machine-learning application.
              </li>
            </ul>

            <h2
              style={{
                color: "#2c3e50",
                fontSize: "1.5rem",
                marginTop: "3rem",
                marginBottom: "1.5rem",
                textAlign: "center",
              }}
            >
              Approach comparison
            </h2>

            <div
              style={{
                margin: "3rem 0",
                textAlign: "center",
              }}
            >
              <img
                src={comparisonTableImage}
                alt="Comparison table of different approaches"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              />
            </div>

            <p style={{ marginBottom: "2rem" }}>
              The above Chart shows that the machine-learning results
              corroborate the expert-guided results. DNA addition increased
              precision to 90%. All approaches used the same psychiatric "ground
              truth" diagnoses targets.
            </p>

            <p
              style={{
                marginBottom: "2rem",
                fontWeight: "500",
                color: "#2c3e50",
              }}
            >
              Anxiety assessment results revealed that machine-learning methods
              significantly outperformed the expert-guided approach.
              <span className="sigmund-text">Sigmund</span> utilizes both
              methods to optimise its own performance.
            </p>
          </div>
        </div>
      </div>
    </SharedLayout>
  );
};

export default ClinicalStudyView;
